import React from 'react';
import ReactDOM from 'react-dom';

import { App } from './bootstrap/application/components/app/App';
import { setToken } from './shared/infrastructure/tokenStore';

const hydrateTokenFromUrl = (): void => {
  const url = new URL(window.location.href);

  const hash = url.hash.slice(1);
  const hashParams = new URLSearchParams(hash);
  const token = hashParams.get('token');

  if (token) {
    setToken(token);
    hashParams.delete('token');
    const newHash = hashParams.toString();
    const cleaned = `${url.pathname}${url.search}${newHash ? `#${newHash}` : ''}`;
    window.history.replaceState(null, '', cleaned);
  }
};

hydrateTokenFromUrl();

ReactDOM.render(<App />, document.getElementById('root'));
